































































































import Vue from "vue";
import { ResetPasswordClient } from "@/api/open-api";
export default Vue.extend({
  name: "Reset",
  data() {
    return {
      reset: new ResetPasswordClient(),
      password: "",
      confirmPassword: "",
      email: "",
      isPwd: true,
      messaggioErrore:
        "le password devono coincidere prima di poter confermare",
    };
  },
  methods: {
    async onsubmit() {
      if (this.password != this.confirmPassword) {
        this.$q.notify({
          progress: true,
          message: "Le password non coincidono",
          type: "negative",
        });
      } else if (this.password.length >= 3) {
        this.$q.loading.show();
        const result = await this.reset.confirmReset({
          email: this.email,
          token: this.$route.params.token,
          newPassword: this.password,
        });

        if (result.success) {
          this.$q.loading.hide();
          this.$router.push("/login");
        } else {
          this.$q.loading.hide();
          this.$q.notify({
            progress: true,
            message: result.error || "",
            type: "negative",
          });
        }
      } else {
        this.$q.loading.hide();
        this.$q.notify({
          progress: true,
          message: "La password deve essere lunga almeno 3 caratteri",
          type: "negative",
        });
      }
    },
  },
});
